export default "__VITE_ASSET__Dh58PS5O__"